import { useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import Swal from "sweetalert2";
import { CloseOutlined, EditOutlined } from "@ant-design/icons";

import icon from "../../assets/static/images/secciones/contribuyente.png";
import { Tabla } from "../../components/Table/Table";
import ModalRowData from "./ModalRowData/ModalRowData";
import AgregarInmueble from "./Inmueble/AgregarInmueble";
import EditarInmueble from "./Inmueble/EditarInmueble";
import { misContribuyenteService } from "../../_services/misContribuyentes.service";
import { grupoEtapasService } from "../../_services/grupoEtapas.service";
import { tipoEtapasService } from "../../_services/tipoEtapas.service";
import { useDispatch } from "react-redux";
import { setLoading } from "../../redux/Loading/actions";
import Select from "../Select/Select";
import { emptyOption } from "../../constants";
import { selectErrorStyles, selectStyles } from "../Select/styles";

const CreateContribuyente = ({ show, handleClose, reload }) => {
  const dispatch = useDispatch();
  const [showInmueble, setShowInmueble] = useState(false);
  const [showEditInmueble, setShowEditInmueble] = useState(false);

  const [inmueble, setInmueble] = useState("");
  const [inmuebles, setInmuebles] = useState([]);
  const [currentValues, setCurrentValues] = useState();
  const [grupos, setGrupos] = useState([]);
  const [tipos, setTipos] = useState([]);
  const [grupo, setGrupo] = useState("");
  const [tipo, setTipo] = useState("");

  const {
    register,
    control,
    handleSubmit,
    formState: { errors }
  } = useForm();

  useEffect(() => {
    const getData = async () => {
      let response = await grupoEtapasService.getGrupoEtapas();

      if (response?.length) {
        setGrupos(response.map(e => {
          return {
            ...e,
            value: e.id,
            label: e.nombre
          };
        }));
      }

    };

    getData();
  }, []);

  useEffect(() => {
    const getData = async () => {
      if (grupo && grupo.id) {
        dispatch(setLoading(true));

        let response = await tipoEtapasService.getTipoEtapas(grupo.id);

        if (response?.length) {
          setTipos(response.map(e => {
            return {
              ...e,
              value: e.tipo,
              label: e.nombre
            };
          }));

          dispatch(setLoading(false));
        }
        else {
          dispatch(setLoading(false));
        }
      }
      else {
        setTipos([]);
      }
    };

    getData();
  }, [grupo]);

  const onSubmit = (newData) => {
    Swal.fire({
      title: "¿Esta seguro de guardar los cambios?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: "No",
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si",
      reverseButtons: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        newData.inmuebles = inmuebles;
        newData.gp_estado = grupo ? grupo.id : "";
        
        dispatch(setLoading(true));

        let response = await misContribuyenteService.createContribuyente(newData);
        reload();

        dispatch(setLoading(false));

        if (response.ok) {
          return Swal.fire({
            title: "Exito!",
            text: "Los datos es guardaron correctamente.",
            icon: "success",
            willClose: () => handleClose()
          });
        }
        else {
          dispatch(setLoading(false));
          return Swal.fire(
            "Error!",
            response.error || "Ocurrio un error, intentelo nuevamente.",
            "error"
          );
        }
      }
    });
  };


  const handleChange = (e) => {
    setCurrentValues({
      ...currentValues,
      [e.target.name]: e.target.value
    });
  };

  const handleOpenInmueble = () => {
    setShowInmueble(true);
  };

  const handleCloseInmueble = () => {
    setShowInmueble(false);
  };

  const handleOpenEdit = () => {
    setShowEditInmueble(true);
  };

  const handleCloseEdit = () => {
    setShowEditInmueble(false);
  };

  const handleEdit = (e, index) => {
    setInmueble({
      ...e,
      index
    });

    handleOpenEdit();
  };

  const handleCancel = ({ inmueble }) => {
    setInmuebles(prev => {
      return prev.filter((e) => e.inmueble !== inmueble);
    });
  };

  const handleSelect = (e) => {
    if (e) {
      setTipo("");
      setGrupo(e);
    }
    else {
      setGrupo("");
    }
  };

  const columns = [
    {
      title: "INMUEBLE",
      dataIndex: "inmueble",
      key: "inmueble",
    },
    {
      title: "RECURSO",
      dataIndex: "recurso",
      key: "recurso",
    },
    {
      title: "OBSERVACIÓN",
      dataIndex: "observaciones",
      key: "observaciones",
    },
    {
      title: "ACCIONES",
      dataIndex: "accion",
      render: (_, row, index) => <div className="d-flex">
        <div>
          <Button
            className="d-flex align-items-center ml-2"
            variant="contained"
            onClick={() => handleCancel(row)}
          >
            <CloseOutlined style={{ color: "red" }} />
          </Button>
        </div>
        <div>
          <Button
            className="d-flex align-items-center ml-2"
            variant="contained"
            onClick={() => handleEdit(row, index)}
          >
            <EditOutlined />
          </Button>
        </div>
      </div>
    },
  ];

  return (
    <Modal
      animation={false}
      show={show}
      onHide={handleClose}
      size="xl"
      className="contribuyente-modal"
      backdrop="static"
    >
      <Modal.Header closeButton />
      <Modal.Body>
        <Form className="contribuyente-form" onSubmit={handleSubmit(onSubmit)}>
          <Row style={{ marginBottom: 50 }}>
            <Col sm={12} md={6}>
              <div className="contribuyente-title">
                <img src={icon} alt="contribuyente" />
                <span>Datos del Contribuyente</span>
              </div>
            </Col>
          </Row>
          <Row className="pb-2">
            <Col sm={12} md={6}>
              <Form.Label className="mb-2" style={{ marginTop: 10 }}>
                Nombre
              </Form.Label>
              <Form.Control
                name="apynom"
                {...register("apynom")}
                onChange={handleChange}
                required
              />
            </Col>
            <Col sm={12} md={6}>
              <Form.Label className="mb-2" style={{ marginTop: 10 }}>DNI</Form.Label>
              <Form.Control
                name="dni"
                {...register("dni")}
                onChange={handleChange}
                required
              />
            </Col>
          </Row>

          <Row className="pb-2">
            <Col sm={12} md={6}>
              <Form.Label className="mb-2" style={{ marginTop: 10 }}>CUIT</Form.Label>
              <Form.Control
                name="cuit"
                {...register("cuit")}
                onChange={handleChange}
              />
            </Col>
            <Col sm={12} md={6}>
              <Form.Label className="mb-2" style={{ marginTop: 10 }}>CUIM</Form.Label>
              <Form.Control
                name="cuim"
                {...register("cuim")}
                onChange={handleChange}
              />
            </Col>
          </Row>

          <Row className="pb-2">
            <Col sm={12} md={4} >
              <Form.Label className="mb-2" style={{ marginTop: 10 }}>Estado</Form.Label>
              <Controller
                name="gp_estado"
                control={control}
                render={({ field: { onChange } }) => {
                  return (
                    <Select
                      options={grupos?.length ? [emptyOption, ...grupos] : [emptyOption]}
                      value={grupo}
                      onChange={(e) => {
                        handleSelect(e);
                        return onChange(e?.value);
                      }}
                    />
                  );
                }}
              />
            </Col>
            {grupo?.value ? (
              <Col sm={12} md={4} >
                <Form.Label className="mb-2" style={{ margin: 11.5, marginTop: 21.5 }}></Form.Label>
                <Controller
                  name="estado"
                  rules={{ required: "El campo es obligatorio" }}
                  control={control}
                  render={({ field: { onChange } }) => {
                    return (
                      <Select
                        options={tipos?.length ? [emptyOption, ...tipos] : [emptyOption]}
                        value={tipo}
                        onChange={(e) => {
                          setTipo(e);
                          return onChange(e?.value);
                        }}
                        styles={errors.estado ? selectErrorStyles : selectStyles}
                      />
                    );
                  }}
                />
                {errors.estado ? (
                  <div
                    className="invalid"
                    style={{
                      fontSize: "80%",
                      color: "#dc3545",
                      marginTop: 4
                    }}
                  >
                    {errors.estado.message}
                  </div>
                ) : ""}
              </Col>
            ) : ""}
          </Row>

          <Row className="pb-2">
            <Col sm={12} md={6}>
              <Form.Label className="mb-2" style={{ marginTop: 10 }}>Calle</Form.Label>
              <Form.Control
                name="calle"
                {...register("calle")}
                onChange={handleChange}
              />
            </Col>
            <Col sm={12} md={6}>
              <Form.Label className="mb-2" style={{ marginTop: 10 }}>Número</Form.Label>
              <Form.Control
                name="nro"
                {...register("nro")}
                onChange={handleChange}
              />
            </Col>
          </Row>

          <Row className="pb-2">
            <Col sm={12} md={6}>
              <Form.Label className="mb-2" style={{ marginTop: 10 }}>Teléfono</Form.Label>
              <Form.Control
                name="telefono"
                {...register("telefono")}
                onChange={handleChange}
              />
            </Col>
            <Col sm={12} md={6}>
              <Form.Label className="mb-2" style={{ marginTop: 10 }}>Email</Form.Label>
              <Form.Control
                name="email"
                {...register("email")}
                onChange={handleChange}
              />
            </Col>
          </Row>

          <Row className="pb-2">
            <Col sm={12} md={12}>
              <Form.Label className="mb-2" style={{ marginTop: 10 }}>Titulo(titular, poseedor, tenedor, responsables)</Form.Label>
              <Form.Control
                name="titulo"
                {...register("titulo")}
                onChange={handleChange}
              />
            </Col>
          </Row>

          <Row className="pb-2">
            <Col sm={12} md={12}>
              <Form.Label className="mb-3" style={{ marginTop: 10 }}>Inmuebles</Form.Label>
              <br />
              <Button
                onClick={handleOpenInmueble}
              >
                Agregar Inmueble
              </Button>
            </Col>
          </Row>

          <br />

          <Row className="pb-2">
            <Col sm={12} md={12}>
              <div className="section-table d-flex justify-content-center">
                <Tabla
                  dataList={inmuebles}
                  columns={columns}
                  expandable={true}
                  selection={false}
                  RowData={ModalRowData}
                />
              </div>
            </Col>
          </Row>

          <br />

          <Row className="justify-content-end">
            <Col style={{ maxWidth: 190 }}>
              <Button
                type="submit"
                className="custom-button"
              >
                <span className="ml-2">Guardar cambios</span>
              </Button>
            </Col>
            <Col style={{ maxWidth: 140 }}>
              <Button
                className="danger-button ml-2"
                variant="danger"
                onClick={handleClose}
              >
                <span className="ml-2">Cancelar</span>
              </Button>
            </Col>
          </Row>
        </Form>

      </Modal.Body>
      {showInmueble ? (
        <AgregarInmueble show={showInmueble} handleClose={handleCloseInmueble} setInmuebles={setInmuebles} />
      ) : false}
      {showEditInmueble ? (
        <EditarInmueble show={showEditInmueble} handleClose={handleCloseEdit} setInmueble={setInmueble} setInmuebles={setInmuebles} inmueble={inmueble} inmuebles={inmuebles} />
      ) : false}
    </Modal>
  );
};


export default CreateContribuyente;
